import {
  React,
  Component,
  withCookies,
  withRouter,
  axios,
  routes
} from 'imports/CommonImports';

import {
  TextField,
  RaisedButton,
  Snackbar
} from 'material-ui';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '16em',
  },
  button: {
    width: '16em',
  },
  forgotPassword: {
    marginBottom: '1.5em',
    marginTop: '1em',
  },
}
class Profile extends Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      open: false,
      message: "",
      old_password:"",
      new_password:"",
      token: this.props.cookies.get('token'),
    };
  }

  render() {
    return (
      <div style={styles.container}>
        <h2>Perfil de usuario</h2>
        <h3>Cambiar contraseña</h3>
        <TextField
          name = "old_password"
          hintText="Escribe tu contraseña"
          floatingLabelText="Contraseña actual"
          type="password"
          errorText={this.getPasswordError()}
          value ={this.state.old_password}
          onChange={this.handleChange}
          inputStyle={styles.input}
        />
        <TextField
          name = "new_password"
          hintText="Escribe tu nueva contraseña"
          floatingLabelText="Contraseña nueva"
          type="password"
          errorText={this.getConfirmError()}
          value ={this.state.new_password}
          onChange={this.handleChange}
          inputStyle={styles.input}
        />
      <RaisedButton primary={true} label="Cambiar Contraseña" onClick={this.handleSubmit} buttonStyle={styles.button}/>
        <Snackbar open={this.state.open} message={this.state.message} autoHideDuration={4000} onRequestClose={this.handleRequestClose} />
      </div>
    );
  }

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  handleChange(event) {
    this.setState({[event.target.name]: event.target.value});
  }

  handleSubmit(event) {
    if(this.getPasswordError() === '' && this.getConfirmError() === '' && this.notEmpty()){
      var data = {old_password:this.state.old_password, new_password:this.state.new_password}
      axios({
        method: 'put',
        headers: {'Authorization': "Token "+ this.state.token},
        url: routes.host + routes.changePassword,
        data: data
      })
      .then((response) => {
        this.setState({
          open: true,
          message: "Se ha cambiado tu contraseña exitosamente.",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          open: true,
          message: "Hubo un error al cambiar tu contraseña.",
        });
      });
    }
    else {
      this.setState({
        open: true,
        message: "Los campos no pueden estar vacíos",
      });
    }
  }

  notEmpty = () => {
    if(this.state.new_password !== '' && this.state.old_password !== ''){
      return true;
    }
    return false;
  }

  getPasswordError = () => {
    if(this.state.new_password.length < 8 && this.state.new_password.length > 0)
      return "La contraseña debe tener al menos 8 caractéres";
    return "";
  }

  getConfirmError = () => {
    if(this.state.new_password === this.state.old_password & this.state.new_password.length > 0)
      return "Las contraseñas no pueden ser iguales";
    return "";
  }
}

export default withRouter(withCookies(Profile));



// WEBPACK FOOTER //
// ./src/components/common/ChangePassword.js